<template>
  <page>
    <template slot="title">О компании</template>
    <template slot="section">
      <!--<columns>
        <column size="4">
          <p>Разнообразный и богатый опыт рамки и место обучения кадров позволяет выполнять важные задания по разработке соответствующий условий активизации. Не следует, однако забывать, что укрепление и развитие структуры требуют определения и уточнения модели развития. </p>
          <heading type="h3" size="xl">2013</heading>
        </column>
        <column size="4">
          <p>Значимость этих проблем настолько очевидна, что дальнейшее развитие различных форм деятельности влечет за собой процесс внедрения и модернизации позиций, занимаемых участниками в отношении поставленных задач. Разнообразный и богатый опыт рамки и место обучения кадров позволяет выполнять важные задания по разработке соответствующий условий активизации.</p>
          <heading type="h3" size="xl">2015</heading>
        </column>
        <column size="4">
          <p>Не следует, однако забывать, что укрепление и развитие структуры требуют определения и уточнения модели развития. Значимость этих проблем настолько очевидна, что дальнейшее развитие различных форм деятельности влечет за собой процесс внедрения и модернизации позиций, занимаемых участниками в отношении поставленных задач.</p>
          <heading type="h3" size="xl">2018</heading>
        </column>
      </columns>-->
      <columns>
        <column size="10">
          <p>АРК-ЭнергоСбыт – независимая энергостбытовая компания, объединившая высококвалифицированных специалистов с многолетним опытом работы в ведущих энергетических компаниях России.</p>
          <p>Основным направлением деятельности компании является надёжная и бесперебойная поставка электроэнергии с учётом индивидуальных потребностей клиентов.</p>
          <p><b>Преимущественные условия энергоснабжения:</b></p>
          <ul>
            <li>снижение стоимости электрической энергии для потребителя</li>
            <li>оптимизация поставки электрорэнергии</li>
            <li>установка и обслуживание автоматизированных систем коммерческого учета электроэнергии (АИИС КУЭ)</li>
            <li>энерготрейдинг и сопровождение оптового рынка электроэнергии для действующих участников</li>
            <li>прозрачное ценообразование и гибкая система платежей</li>
            <li>обеспечение возможности точного планирования потребителем затрат на энергоресурсы</li>
            <li>клиентоориентированный индивидуальный подход</li>
            <li>обеспечение надежности поставки</li>
            <li>комплексное юридическое сопровождение и обеспечение безопасности</li>
          </ul>
        </column>
        <!--<column size="4" align="right">
          <line-break/>
          <quote>
            <heading rl>«Этим ребятам я бы доверял!»</heading>
            <p rl>Владимир Путин</p>
          </quote>
        </column>-->
      </columns>
      <!--<img id="scrollAnchor" class="decorate" :src="waves"/>
      <heading :center="true">Руководство</heading>
      <columns>
        <column size="6">
          <person-card>
            <template slot="avatar">
              <avatar src=""/>
            </template>
            <template>
              <heading :center="true" type="h5" size="m">Казанцев Станислав Александрович</heading>
              <heading :center="true" type="h6">Генеральный директор</heading>
            </template>
            <template slot="contacts">
              <p>Контакт 1</p>
              <p>Контакт 2</p>
              <p>Контакт 3</p>
            </template>
          </person-card>
        </column>
        <column size="6">
          <person-card>
            <template slot="avatar">
              <avatar src=""/>
            </template>
            <template>
              <heading :center="true" type="h5" size="m">Казанцев Станислав Александрович</heading>
              <heading :center="true" type="h6">Генеральный директор</heading>
            </template>
            <template slot="contacts">
              <p>Контакт 1</p>
              <p>Контакт 2</p>
              <p>Контакт 3</p>
            </template>
          </person-card>
        </column>
      </columns>-->
    </template>
    <template slot="aside">
      <transition name="fade" mode="out-in">
        <aside-image v-if="showSecondBg" :key="showSecondBg" :image="imageBg2"/>
        <aside-image v-else :key="showSecondBg" :image="imageBg"/>
      </transition>
    </template>
  </page>
</template>

<script>
import imageBg from '../../static/i/img-04.jpg';
import imageBg2 from '../../static/i/img-08.jpg';
import waves from '@/assets/waves_bl.svg';

import Columns from '@/components/columns/Columns';
import Column from '@/components/columns/Column';
import Page from '@/components/Page';
import AsideImage from '@/components/AsideImage';

export default {
  components: {
    Columns,
    Column,
    Page,
    AsideImage,
  },
  data () {
    return {
      imageBg: imageBg,
      imageBg2: imageBg2,
      waves: waves,
      showSecondBg: false,
    }
  },
  mounted () {
    this.anchor = document.getElementById('scrollAnchor');
    //window.addEventListener('scroll', this.scrollHandler);
    //this.scrollHandler();
  },
  beforeDestroy () {
    //window.removeEventListener('scroll', this.scrollHandler);
  },
  methods: {
    /*scrollHandler (evt) {
      this.showSecondBg = (evt ? evt.target.scrollingElement.scrollTop : window.scrollTop) >= (this.anchor.offsetTop - window.innerHeight);
    }*/
  },
}
</script>

<style lang="scss">
.decorate {
  height: 100px;
  display: block;
  margin: 0 0 0 -50px;
}
.column h3 {
  margin-left: -12px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// About.vue?79d5c730